module.exports = __webpack_public_path__ + "img/td.e99b6682.svg";